import script from "./TorneoBrackets.vue?vue&type=script&setup=true&lang=js"
export * from "./TorneoBrackets.vue?vue&type=script&setup=true&lang=js"

import "./TorneoBrackets.vue?vue&type=style&index=0&id=be6a7432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be6a7432"]])

export default __exports__